<template>
    <ValidationProvider 
        :name="field"
        :rules="rules"
        v-slot="{ errors }"
        slim
    >
        <v-select
            v-model="selected"
            :items="items" 
            :label="label"  
            :error-messages="errors"       
            :clearable="clearable"
            :readonly="readonly"
            :multiple="multiple"
            menu-props="offset-y"
            :class="withMargin ? 'ml-4 mr-4' : ''"
            @click:clear="resetVal()"
            @change="additionalFunction(selected)"
            :item-text="itemText"
            :item-value="itemValue"  
            :disabled="disabled"
            :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
            :hide-details="hideDetails"
            :alvqa="alvqa"
            item-color="generalCheckbox"
        >

            <template v-slot:item="{ item }">
                 <v-list-item-content :alvqa="alvqa + '-dropdown-az-' + item.alvId">
                      <v-list-item-title :alvqa="alvqa + '-dropdown-az-' + item.alvId + '-title'">
                        {{ item.gemaName }} <v-avatar color="grey" size="20" class="caption">{{ item.typeOfAz }}</v-avatar>
                      </v-list-item-title>
                    <v-list-item-subtitle :alvqa="alvqa + '-dropdown-az-' + item.alvId + '-subtitle'">
                        {{ item.alvId }}                                      
                    </v-list-item-subtitle>
                 </v-list-item-content>
            </template>
            
            <!-- 26.10.2020: this was below in the template but seems not needed: v-if="selection" -->
            <template 
                v-slot:selection="{ item, index }"
            >
                <span v-if="index === 0">
                    <div 
                        :alvqa="alvqa"
                    >{{ item.gemaName }}</div>
                </span>
                <div v-if="index === 1">  (+{{ selected.length - 1 }} others)</div>
            </template>
            
        </v-select>
    </ValidationProvider>
</template>

<script>
import BaseDropdown from '../_base/BaseDropdown'

export default {
    name: "BaseEditPageDropdownAz",
    extends: BaseDropdown,
    props: {
        context: String,
        field: String,
        hideDetails: Boolean,
        alvqa: {
            type: String,
            default: ''
        },
        itemValue: {
            type: String | Function,
            default: "value"
        },
        itemText: {
            type: String | Function,
            default: "text"
        },
        selection: {
            default: false,
            type: Boolean
        },
        clearable: {
            default: true
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        withMargin: {
            type: Boolean,
            default: true
        },
        additionalFunction: {
            type: Function,
            default: () => {}
        },
    },
    computed: {
        selected: {
            // get and set of selection VALUE (e.g. "1" or "2", but not of selection TEXT)
            get() { return this.$store.getters['get'+ this.context + 'Details' + this.field] },
            set(value) { return this.$store.commit('set'+ this.context + 'Details' + this.field, value) }
        }
    },
    methods: {
        async resetVal() {
            await this.$nextTick()
            this.selected = []
        }
    },
    
}
</script>